import { route } from '@/utils/build'
const component = path => resolve => require(['@/pages/payment/views/' + path], resolve)

/**
 * 无限卡抵扣
 */
export default [route('/infinite', 'infinite', component('infinite/index'))]
